import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

const templateEditorCanvasStyles: IStyles = {
    canvasArea: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        minHeight: 0,
        position: 'relative',
        overflow: 'hidden',
    },
    viewport: {
        flex: 1,
        minHeight: 0,
        overflow: 'auto',
        position: 'relative',
        overscrollBehavior: 'contain',
        background: `
            radial-gradient(ellipse at 20% 0%, ${color.blue100}, transparent 45%),
            radial-gradient(ellipse at 90% 100%, ${color.info100}, transparent 40%),
            ${color.borderDarkPrimary}
        `,
        padding: 72,
    },
    zoomHost: {
        minWidth: 'min-content',
        minHeight: 'min-content',
        margin: '0 auto',
        width: 'fit-content',
    },
    wrapper: {
        position: 'relative',
        transformOrigin: '0 0',
    },
    frame: {
        position: 'relative',
        background: color.bgWhitePrimary,
        boxShadow: `
            0 0 0 1px ${color.blue200},
            0 8px 40px ${color.bgAlphaDark300},
            0 0 0 1px ${color.info100}
        `,
        borderRadius: 2,
        overflow: 'hidden',
    },
    bgMedia: {
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        pointerEvents: 'none',
        zIndex: 0,
    },
    canvasAreaPlacing: {
        cursor: 'crosshair',
    },
    grid: {
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
    },
    rulerH: {
        position: 'absolute',
        top: 0,
        left: 24,
        right: 0,
        height: 24,
        background: color.bgWhitePrimary,
        border: `1px solid ${color.borderDarkPrimary}`,
        fontSize: 9,
        color: color.fontDarkUltraLow,
        zIndex: 5,
        pointerEvents: 'none',
    },
    rulerV: {
        position: 'absolute',
        top: 24,
        left: 0,
        bottom: 0,
        width: 24,
        background: color.bgWhitePrimary,
        border: `1px solid ${color.borderDarkPrimary}`,
        fontSize: 9,
        color: color.fontDarkUltraLow,
        zIndex: 5,
        pointerEvents: 'none',
    },
}

addStyles(templateEditorCanvasStyles)
export default templateEditorCanvasStyles
